import ReactDOM from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
import './index.css';
import App from './App';
import './css/themes.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
);
